import {
    GET_ACCOUNT_TYPE_ADMIN_SUCCESS,
    GET_ACCOUNT_TYPE_ADMIN_FAILED,
    LOADING_GET_ACCOUNT_TYPE_ADMIN,
    RESET_GET_ACCOUNT_TYPE_ADMIN,
    NETWORK_ERROR_GET_ACCOUNT_TYPE_ADMIN,
} from "../types/index";
import { adminServices } from "../../config/axios";

const resetGetAccountTypeAdmin = () => {
    return { type: RESET_GET_ACCOUNT_TYPE_ADMIN };
};

const getAccountTypeAdmin = (userData, authTokenIs) => async (dispatch) => {
    dispatch({ type: LOADING_GET_ACCOUNT_TYPE_ADMIN });
    await adminServices
        .post("getAccttypeAdmin", userData, { headers: { AuthToken: authTokenIs } })
        .then((res) => {
            switch (res.data.status) {
                case "success":
                    dispatch({ type: GET_ACCOUNT_TYPE_ADMIN_SUCCESS, payload: res.data });
                    break;
                default:
                    dispatch({ type: GET_ACCOUNT_TYPE_ADMIN_FAILED, payload: res.data });
                    break;
            }
        })
        .catch((err) => {
            dispatch({ type: NETWORK_ERROR_GET_ACCOUNT_TYPE_ADMIN, payload: err });
        });
};

export { resetGetAccountTypeAdmin, getAccountTypeAdmin };